// Historische Tagespreise für Wallet-/On-Chain-Importzeilen nachladen.
//
// Spiegelt die Inline-Preis-Logik des Wallet-Imports (ChainWalletConnect) als EINE
// wiederverwendbare Funktion — genutzt von der „Zu prüfen"-Übernahme (WalletRegistry),
// damit Kandidaten mit korrektem EUR-Preis (und damit Cost-Basis) in den Review gehen,
// statt mit preis:0 (sonst greift nur der Datencheck no_basis).
//
// Rein lesend (coin-price-history je coinId+Datum), kein Schreibzugriff. Die Engine
// (FIFO/Bestand) bleibt unberührt — hier wird nur das `preis`-Feld der Importzeilen
// gesetzt, bevor sie durch den normalen Review-/Import-Pfad laufen.

import { authHeader } from '../services/authHeader';

const API_BASE = process.env.REACT_APP_API_BASE || '';

/**
 * Setzt preis/stueck auf den Importzeilen anhand historischer Tagespreise.
 * Nur für Zeilen ohne Preis (preis 0/leer), mit coinId + Datum + menge>0.
 * @param {Array} rows  kanonische Importzeilen (tx-Form)
 * @param {{onProgress?:(done:number,total:number)=>void}} opts
 * @returns {Promise<Array>} neue Zeilen mit preis/stueck/hash gesetzt
 */
export async function priceWalletRows(rows, { onProgress } = {}) {
  const list = Array.isArray(rows) ? rows : [];
  let auth = {};
  try { auth = await authHeader(); } catch { /* ohne Auth → Fallback ohne Preise */ }

  const keys = new Set();
  const jobs = [];
  for (const tx of list) {
    if (tx.coinId && tx.datum && (!tx.preis || tx.preis === 0) && tx.menge > 0) {
      const k = `${tx.coinId}|${tx.datum}`;
      if (!keys.has(k)) { keys.add(k); jobs.push({ coinId: tx.coinId, sym: tx.coin, datum: tx.datum }); }
    }
  }

  const priceMap = {};
  for (let i = 0; i < jobs.length; i++) {
    const { coinId, sym, datum } = jobs[i];
    try {
      const symQ = sym ? `&sym=${encodeURIComponent(sym)}` : '';
      const r = await fetch(
        `${API_BASE}/api/coin-price-history?coin=${encodeURIComponent(coinId)}&date=${encodeURIComponent(datum)}&currency=eur${symQ}&cv=2`,
        { headers: auth },
      );
      if (r.ok) {
        const d = await r.json();
        if (typeof d.price === 'number') priceMap[`${coinId}|${datum}`] = d.price;
      }
    } catch { /* einzelne Preise dürfen fehlen */ }
    onProgress?.(i + 1, jobs.length);
    if (i < jobs.length - 1) await new Promise(res => setTimeout(res, 80));
  }

  return list.map(tx => {
    const p = priceMap[`${tx.coinId}|${tx.datum}`];
    const preis = (p != null && tx.menge > 0) ? p * tx.menge : (tx.preis || 0);
    return {
      ...tx,
      preis,
      stueck: tx.menge > 0 ? preis / tx.menge : (tx.stueck || 0),
      hash: tx.hash || tx.txHash || '',
    };
  });
}
